import * as React from 'react';
import { Link } from 'react-router-dom';
import GeneralMessage from '../ui/general-message';
var NotFound = function () {
    return (React.createElement("article", null,
        React.createElement(GeneralMessage, { type: "warning", title: "404", description: 'Page Not Found' }),
        React.createElement(Link, { to: "/" }, " Back to VIN lookup")));
};
export default NotFound;
